export { default } from './SingleClickHoldsForm';



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/SingleClickHoldsForm/index.js